import Vue from 'vue'
import store from '@/store'
import FilterService from '@/service/filter/FilterService'

Vue.filter('abs', function (value) {
  return Math.abs(value)
})

Vue.filter('image', function (value) {
  return value.replace(/^(?:https?:)/, '')
})

Vue.filter('defaultImage', function (value) {
  return require('@/assets/images/talk/category/' + value + '.png')
})

Vue.filter('toCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  let formatter = new Intl.NumberFormat('ko-KR', {
    minimumFractionDigits: 0
  })
  return formatter.format(value)
})

Vue.filter('dateFormat', function (datetime) {
  if (!datetime) {
    return ''
  }
  let d = datetime.split('T')
  let ymd = d[0]
  return `${ymd}`
})

Vue.filter('bankName', value => {
  let inputBankCode = Number(value)
  let banks = store.getters['filter/getBanks']
  let filteredBank = ''

  if (!banks) {
    FilterService.setBanks()
  } else {
    banks.some(bank => {
      if (Number(bank.bankCode) === inputBankCode) {
        filteredBank = bank.bankName
        return true
      }
    })
  }
  return filteredBank
})

Vue.filter('formatRegBuzNo', function (value) {
  let formattedtRegBuzNo = value.slice(0, 3) + '-' + value.slice(3, 5) + '-' + value.slice(5, 10)
  return formattedtRegBuzNo
})

export function commaFormat(value) {
  if (!value) return '0'
  const strNumber = value.toString().replace(/[^\d\\-]/g, '')
  const plainNumber = Number(strNumber).toString()
  return plainNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
Vue.filter('commaFormat', commaFormat)

export function commaRemove(value) {
  return value.replace(/[^\d]/g, '')
}

Vue.filter('commaRemove', commaRemove)
